import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { DamserviceService } from "../dam/damservice.service";
import { AuthService } from "angularx-social-login";
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from '../google-analytics.service';
import AOS from 'aos';

@Component({
  selector: 'app-public-profile',
  templateUrl: './public-profile.component.html',
  styleUrls: ['./public-profile.component.css']
})
export class PublicProfileComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private damService: DamserviceService,
    private authService: AuthService,
    private modalService: NgbModal,
    private activateRoute: ActivatedRoute,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
   }

  profileSection: boolean = true
  showMyProjects: boolean = false;
  showMyUploads: boolean = true;
  showMyFollowers: boolean = false;
  showRatings: boolean = false;
  showAbout: boolean = false;

  showSocialHandles: boolean = false;
  showProjects: boolean = true;

  isSelected: boolean[] = [true, false, false, false];
  showNoDataIllus: boolean = false;
  mobileViewSection: boolean = false;
  noDataSection: boolean = false;
  isMobile: any;

  stars: number[] = [1, 2, 3, 4, 5];
  selectedStar: number = 0;

  showRewardsHistoryData: boolean = false;
  showMoreListItems: boolean = true;
  searchUser: string = '';

  myUploadsImagesList = [];
  myUploadsImagesLength: any;

  currentUser: User;
  mobileView: boolean = false;
  userPic: any;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  planName: string;
  ownerEmail: String;
  ownerName: String;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  workspaceCountAllowed: any;
  totalWorkspaceCreated: any;
  planId: any;
  showLoader: boolean = false;
  showTopRightLoader: boolean = false;
  sendSuccessfulErrorMsg: boolean = false;
  sendSuccessfulErrorMessage: string;
  successfullMessage: string;
  sendSuccessfulMsg: boolean = false;

  userMainName: any;
  userMainPic: any;
  userTitle: any;
  userLocation: any;
  userBio: any;
  twitterLink: any;
  instagramLink: any;
  dribbbleLink: any;
  behanceLink: any;
  linkedinLink: any

  showTwitter: boolean = false;
  showInsta: boolean = false;
  showDribbble: boolean = false;
  showBehance: boolean = false;
  showLinkedin: boolean = false;

  currentIllus: any;
  currentAssetId: any;
  currentUrlsAssetId: any;
  currentIllusPosition: any;
  public selectedFormatIndex;
  imageDownloadShowFormat: any;
  showNextIcon: boolean = true;
  showPreviousIcon: boolean = true;

  returnUrl: any;
  user_from: string;
  user_token: string;

  @ViewChild('imgMainModal') imgMainModal;

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'];
      this.user_from = params['from'];
      this.user_token = params['token'];
    });

    this.listMyUploadImages();

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });

    this.metaTagService.addTags([
      { name: 'description', content: 'Workspace profile that showcase your work via publish public or to anyone you want with just one shareable link.'},
      { name: 'keywords', content: 'profile, user profile, account, work, artwork, designs' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    AOS.init();

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.profileSection = false;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.profileSection = true;
      this.mobileView = false;
    }

    if(this.currentUser) {
      this.getWorkspaceDetails();
    } else {
      // this.listMyUploadImages();
    }
  }

  @ViewChild(PdfViewerComponent, {static: false})
  private pdfComponent: PdfViewerComponent;
  pageRendered() {
    this.pdfComponent.pdfViewer.currentScaleValue = 'page-fit';
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.ownerListApi();
      this.getUserPic();
      // this.listMyUploadImages();
    },
    (error) => {
      if (this.currentUser) {
        if(error.status == 500){
        } else {

        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
      this.totalWorkspaceCreated = data.total_workspace_created;
    });
  }

  mainClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  openLoginScreen() {
    this.router.navigate(['/login']);
  }

  backToWorkspace() {
    this.router.navigate(['/dam']);
  }

  goToSubscription() {
    this.router.navigate(['/dam/subscription']);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  starState(star: number) {
    return star <= this.selectedStar ? 'assets/img/star-golden.svg' : 'assets/img/star-black.svg';
  }

  viewRewards() {
    this.showRewardsHistoryData = true;
    this.showMoreListItems = false;
  }

  viewWorkHistory() {
    this.showRewardsHistoryData = true;
    this.showMoreListItems = false;
  }

  showMainMoreSection() {
    this.showRewardsHistoryData = false;
    this.showMoreListItems = true;
  }

  projectsClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = true;
    this.showMyUploads = true;
    this.showMyFollowers = false;
    this.showRatings = false;
    this.showAbout = false;
  }

  follwoingClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = false;
    this.showRatings = false;
    this.showMyFollowers = true;
    this.showAbout = false;
  }

  ratingClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = false;
    this.showMyFollowers = false;
    this.showAbout = false;
    this.showRatings = true;
  }

  aboutClick(index: number) {
    this.isSelected = this.isSelected.map((item, i) => i === index);
    this.showMyProjects = false;
    this.showMyUploads = false;
    this.showMyFollowers = false;
    this.showRatings = false;
    this.showAbout = true;
  }

  onSubmitUser() {

  }

  openFigma() {
    if(this.currentUser) {
      this.googleAnalyticsService.event('public_figma_clicked', 'figma_clicked', this.currentUser.firstName +" "+this.currentUser.lastName);
    } else {
      this.googleAnalyticsService.event('public_figma_clicked', 'figma_clicked', 'Guest User');
    }
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    if(this.currentUser) {
      this.googleAnalyticsService.event('public_sketch_clicked', 'sketch_clicked', this.currentUser.firstName +" "+this.currentUser.lastName);
    } else {
      this.googleAnalyticsService.event('public_sketch_clicked', 'sketch_clicked', 'Guest User');
    }
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    if(this.currentUser) {
      this.googleAnalyticsService.event('public_ai_clicked', 'ai_clicked', this.currentUser.firstName +" "+this.currentUser.lastName);
    } else {
      this.googleAnalyticsService.event('public_ai_clicked', 'ai_clicked', 'Guest User');
    }
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  listMyUploadImages(){
    this.showTopRightLoader = true;
    this.damService.listPublicProfileUploadImages(this.user_token).subscribe((data: any) => {
      this.showTopRightLoader = false;
      this.showSocialHandles = data.social_data.share_social;
      this.showProjects = data.social_data.share_project;
      this.userMainName = data.social_data.first_name + " " +data.social_data.last_name;
      this.userMainPic = data.social_data.user_pic;
      this.userTitle = data.social_data.title;
      this.userLocation = data.social_data.location;
      this.userBio = data.social_data.bio;
      this.twitterLink = data.social_data.twitter_link;
      this.instagramLink = data.social_data.instagram_link;
      this.dribbbleLink = data.social_data.dribble_link;
      this.behanceLink = data.social_data.behance_link;
      this.linkedinLink = data.social_data.linkdin_link;
      this.titleService.setTitle(this.userMainName + " profile | Workspace | Crafttor");

      if(data['project_data'].length == 0){
        this.showNoDataIllus = true;
      }else{
        this.showNoDataIllus = false;
        this.myUploadsImagesList = data['project_data'];
        this.myUploadsImagesLength = data['project_data'].length;
      }
    },
    (error: any) => {
      if(error.status == 400){
        this.profileSection = false;
        this.noDataSection = true;
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      } else {
        this.showTopRightLoader = false;
        this.sendSuccessfulErrorMsg = true
        this.sendSuccessfulErrorMessage = error.error.message;
        this.hideSuccesfullFunctionErrorDelete();
      }
   });
  }

  hideSuccesfullFunctionErrorDelete(){
    setTimeout(() => {
      this.sendSuccessfulErrorMsg = false;
    }, 5000);
  }

  openImgDialog(modal, imgName: string, imgPosition: any,
    currentAssetId: any, format: any){
    this.currentAssetId = currentAssetId
    this.currentIllusPosition = imgPosition;
    this.selectedFormatIndex = 0;
    this.imageDownloadShowFormat = format;
    if(imgPosition == this.myUploadsImagesList.length-1) {
      this.showNextIcon = false;
      this.showPreviousIcon = true;
    } else if(imgPosition == 0){
      this.showPreviousIcon = false;
      this.showNextIcon = true;
    } else {
      this.showPreviousIcon = true;
      this.showNextIcon = true;
    }
    this.imgMainModal = this.modalService.open(modal, { centered: true, windowClass: 'svg-modal ' });
  }

  nextImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviousIcon = true;
    this.selectedFormatIndex = 0;
    if(currentIllusPos == this.myUploadsImagesList.length-2) {
      this.showNextIcon = false;
    }
    if(currentIllusPos <= this.myUploadsImagesList.length-2) {
      for(var i = 0 ; i < this.myUploadsImagesList.length ; i++) {
        this.currentIllus = this.myUploadsImagesList[currentIllusPos+1];
      }
      this.currentIllusPosition = currentIllusPos+1;
    } else {
      //
    }
  }

  previousImage(currentIllusPos: any) {
    this.showNextIcon = true;
    this.showPreviousIcon = true;
    this.selectedFormatIndex = 0;
    if(currentIllusPos == 0) {
      this.showPreviousIcon = false;
    } else {
      for(var i = 0 ; i < this.myUploadsImagesList.length ; i++) {
        this.currentIllus = this.myUploadsImagesList[currentIllusPos-1];
      }
      this.currentIllusPosition = currentIllusPos-1;
    }
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

}
